module.exports = __webpack_public_path__ + "img/selected5-min.4d946113.png";